var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97463 2.08036C6.29473 1.2049 7.5329 1.2049 7.853 2.08037L8.54758 3.98002C8.69176 4.37434 9.06689 4.6366 9.48674 4.63662L11.4591 4.63668C12.4561 4.63672 12.8391 5.93591 12.0016 6.47675L10.6167 7.37108C10.2243 7.62448 10.0596 8.11576 10.2199 8.55447L10.7952 10.1281C11.1245 11.0291 10.1194 11.8319 9.31354 11.3116L7.45624 10.1124C7.12605 9.89916 6.70158 9.89916 6.37139 10.1124L4.51409 11.3116C3.70823 11.8319 2.70311 11.0291 3.03244 10.1281L3.60768 8.55447C3.76804 8.11576 3.60334 7.62448 3.21095 7.37108L1.82604 6.47675C0.988529 5.93591 1.37153 4.63672 2.36849 4.63668L4.34089 4.63662C4.76074 4.6366 5.13587 4.37434 5.28004 3.98002L5.97463 2.08036Z",
    fill: "#A7DAFF",
    stroke: "#44B1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.98c033b1e529c30fcdb59fdc51790b5e.svg";
export { ForwardRef as ReactComponent };